import Vue from 'vue'
import App from './App'

/* eslint-disable no-new */
new Vue({
  el: 'app',
  components: { App},
  render: (h) => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js